import { ICurrency } from '@/types/Currency';
import { EnumPaymentFrequency, EnumPlans, EnumPaymentTypes } from '@/enums/Plans';
import { IPlan } from '@/types/Plans';

export const getPlanPricing = (
  planType: EnumPlans,
  paymentFrequency: EnumPaymentFrequency,
  currency: ICurrency
): number => {
  if (!currency) {
    return 0;
  }
  return (
    [planType, paymentFrequency, currency.key].reduce(
      (sum, curr) => sum && sum[curr],
      planPricing
    ) || 0
  );
};

export const getPlans = (): IPlan[] => [
  {
    key: 'annual',
    name: 'Annual billing - Credit card',
    paymentFrequency: {
      key: EnumPaymentFrequency.annual,
      months: 12,
    },
    paymentType: EnumPaymentTypes.card,
  },
  {
    key: 'annual-invoice',
    name: 'Annual billing - Invoice',
    paymentFrequency: {
      key: EnumPaymentFrequency.annual,
      months: 12,
    },
    paymentType: EnumPaymentTypes.invoice,
  },
  {
    key: 'monthly',
    name: 'Monthly billing - Credit card',
    paymentFrequency: {
      key: EnumPaymentFrequency.monthly,
      months: 1,
    },
    paymentType: EnumPaymentTypes.card,
  },
];

export const getBillingCurrencies = (): ICurrency[] => [
  {
    name: 'Dollar',
    symbol: '$',
    position: 0,
    description: 'US Dollar',
    key: 'USD',
  },
  { name: 'Euro', symbol: '€', position: 0, description: 'Euro', key: 'EUR' },
  {
    name: 'Krona',
    symbol: 'kr',
    position: 1,
    description: 'Svenska kronor',
    key: 'SEK',
  },
  {
    name: 'Krone',
    symbol: 'kr',
    position: 1,
    description: 'Danske kroner',
    key: 'DKK',
  },
  {
    name: 'Krone',
    symbol: 'kr',
    position: 1,
    description: 'Norske kroner',
    key: 'NOK',
  },
];

const planPricing = {
  [EnumPlans.starter]: {
    [EnumPaymentFrequency.monthly]: {
      USD: 40,
      SEK: 350,
      NOK: 350,
      DKK: 280,
      EUR: 35,
    },
    [EnumPaymentFrequency.annual]: {
      USD: 25,
      SEK: 250,
      NOK: 250,
      DKK: 200,
      EUR: 25,
    },
  },
  [EnumPlans.business]: {
    [EnumPaymentFrequency.monthly]: {
      USD: 40,
      SEK: 350,
      NOK: 350,
      DKK: 280,
      EUR: 35,
    },
    [EnumPaymentFrequency.annual]: {
      USD: 40,
      SEK: 350,
      NOK: 350,
      DKK: 280,
      EUR: 35,
    },
  },
  [EnumPlans.enterprise]: {
    [EnumPaymentFrequency.monthly]: {
      USD: 60,
      SEK: 500,
      NOK: 500,
      DKK: 400,
      EUR: 50,
    },
    [EnumPaymentFrequency.annual]: {
      USD: 60,
      SEK: 500,
      NOK: 500,
      DKK: 400,
      EUR: 50,
    },
  },
};
